import {
  ActionAddAvailableRack,
  ActionBaseAvailableRack,
  ActionDeleteAvailableRack,
  ActionEditAvailableRack,
  ActionSetAvailableRacks,
  ActionTypesAvailableRacks,
  IAvailableRack,
} from "./actionTypes";

interface IState {
  available: IAvailableRack[];
}

const MOCK: IAvailableRack[] = [
  { id: "00gfh1", rack_type: [2, 10], rack_items: [] },
  { id: "0345ertg02", rack_type: [4, 10], rack_items: [] },
  { id: "0dfgh45erthdgfb3", rack_type: [3, 10], rack_items: [] },
];

const initial: IState = {
  available: MOCK,
};

const reducer = (
  state: IState = initial,
  action: ActionBaseAvailableRack
): IState => {
  switch (action.type) {
    case ActionTypesAvailableRacks.SET_AVAILABLE_RACKS:
      return {
        ...state,
        available: (action as ActionSetAvailableRacks).payload,
      };
    case ActionTypesAvailableRacks.DELETE_AVAILABLE_RACK:
      const deletedId = (action as ActionDeleteAvailableRack).payload;

      const filtered = state.available.filter((item) => item.id !== deletedId);

      return {
        ...state,
        available: filtered,
      };
    case ActionTypesAvailableRacks.EDIT_AVAILABLE_RACK:
      const edited = (action as ActionEditAvailableRack).payload;

      const index = state.available.findIndex((item) => item.id === edited.id);

      const editedRacks = [
        ...state.available.slice(0, index),
        edited,
        ...state.available.slice(index + 1),
      ];

      return {
        ...state,
        available: editedRacks,
      };
    case ActionTypesAvailableRacks.ADD_AVAILABLE_RACK:
      const added = (action as ActionAddAvailableRack).payload;
      return {
        ...state,
        available: [...state.available, added],
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
